import { RuntimeBaseError } from "@/domains/errors/kinds/RuntimeBaseError";

export class RuntimeAssertionError extends RuntimeBaseError {}
